import styled from 'styled-components';
import {motion} from "framer-motion";

export const StyledPresta = styled(motion.section)`
    overflow: hidden;
    padding: 5rem 0rem;
    width: 80%;
    margin: auto;
    p{
        white-space: nowrap;
        font-size: clamp(0.5rem, 4cqw, 1.2rem);
        padding: .4rem 0rem;
    }
    .content{
        margin: auto;
    }

    .presta-titre{
        justify-content: center;
        text-align: center;
        padding: 2rem 0rem;
    }

    .grille-prix{
        display: flex;
        flex-direction: column;
    }
    .section{
        display: grid;
        grid-template-columns: 2fr 5fr 3fr 1fr 1fr;
    }

    .presta-class{
        padding: 3rem 0rem;
    }

    .type{
        color: rgb(150, 150, 150);
    }

    .genre, .prestation, .details, .prix, .duree{
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }

    .prix, .duree{
        text-align: end;
    }
    .prestation, .details{
        text-align: start;
    }

    .prix, .duree{
        flex: 1
    }

    .details{
        flex: 2;
    }
    .prestation{
        justify-content: space-evenly;
        flex: 5
    }
    .genre{
        flex: 2;
        height: initial;
        justify-content: center;
        align-items: center;
    }
    
    .subcell{
        flex: 1,
        box-sizing: border-box;
    }

    .femme{
        background: #f4f4f4;
    }

    .techniques{
        .femme, .homme{
            .genre{
                flex: 2
            }
            .prestation{
                flex: 4
            }  
            .prix{
                flex: 3
            }
        }
    }

    @media (max-width: 768px){
        width : 90%;
        padding: 2rem 0rem;
        p{
            font-size: clamp(0.5rem, 4cqw, 1rem);
            white-space: normal;
        }

        .type{
            display: none;
        }
/* 
        .separator{
            display: none;
        }
         */
        .genre,.prestation,.details,.prix,.duree{
            padding: 1rem 0rem;
        }

        .femme, .homme, .enfant{
            padding: 0rem .5rem;
            width: 100%;
            display: grid;
            grid-template-columns: 4fr 2fr 1fr 1fr;
            grid-template-rows: auto 1fr;
            column-gap: .5rem;
            grid-template-areas:
                "a a a a"
                "b c d e";
        }
        .genre{ grid-area: a}
        .prestation{ grid-area: b}
        .details{ grid-area: c}
        .prix{ grid-area: d}
        .duree{ grid-area: e}

        .prestation, .details, .prix, .duree{
            justify-content: space-around;
        }

        .techniques{
            .femme, .homme{
                display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: .5rem;
                grid-template-areas:
                    "a a"
                    "b d";
                }
        }
}

`

export const StyledPrestaTest = styled(motion.section)`
    overflow: hidden;
    padding: 2rem 0rem;
    width: 80%;
    margin: auto;

    p{
        white-space: nowrap;
        font-size: clamp(0.5rem, 4cqw, 1.2rem);
        padding: .4rem 0.2rem;
    }

    .grille-prix{
        display: flex;
        flex-direction: column;
    }
    
    .presta-titre{
        justify-content: center;
        text-align: center;
        padding: 2rem 0rem;
    }

    .content{
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .genre{
        flex: 2;
        align-self: center;
    }

    .data-content{
        display: flex;
        flex: 9;
        flex-direction: column;
    }

    .row{
        display: grid;
        grid-template-columns: 6fr 3fr 1fr 1fr;
    }

    .row *{
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }
    .prix, .duree{
        text-align: end;
    }

    .femme{
        background: #f4f4f4;
    }

    .presta-titre-techniques{
        .row{
            grid-template-columns: 3fr 0 1fr 0;}
    }

    @media (max-width: 768px){
        width : 90%;
        padding: 2rem 0rem;
        p{
            font-size: clamp(0.5rem, 4cqw, 1rem);
            white-space: normal;
        }

        .genre{
            padding: 1rem 0rem;
        }

        .content{
            flex-direction: column;
        }
}
`

export const StyledResa = styled(motion.div)`
    min-height: 85vh;
    padding: 5rem 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #6190e8, #a7bfe8);

    .confirm-msg{
        padding: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2rem;
    }
    h6{
        font-size: 1rem;
        color: black;
        right: 0;
    }

    .content{
        display: flex;
        background-color: white;
        border-radius: 20px;
    }

    .txt-left{
        flex: 2;
        // padding: 5rem 2rem 5rem 5rem;
        padding: 5rem;
        h5{
            padding: 1rem 0;
        }
        p{
            font-size: 1.2rem;
        }
    }

    .reservation{
        display: flex;
        flex-direction: column;
        flex: 3;
        padding: 5rem 5rem 5rem 2rem;
    }
    
    .customer-infos{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 1rem;
        padding: 2rem 0rem;
    }

    .input-container{
        position: relative;
    }

    .placeholder{
        position: relative;
        z-index: 1;
        pointer-events: none;
        padding: .3rem 0rem;
        font-size: .9rem;
        transform-origin: left;
        color: #777474;
    }

    .input{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        border: none;
        outline: none;
        color: #777474;
    }
    .line-svg{
        position: absolute;
        bottom: 0;
        width: 100%;
        overflow: visible;
        opacity: .8;
    }

    .selection{
        display: flex;
        justify-content: flex-start;
        padding: 2rem 0rem;
        width: 50%;
    }
    .date,.time{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .date-selector{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        p{
            font-size: .8rem;
            padding-right: 2rem;
        }
    }

    .input-date{
        position: relative;
        width: 7rem;
        height: 2rem;
    }

    select{
        border: none;
    }

    @media (max-width: 768px){
        padding: 0rem 0rem;
        background: white;

        .content{
            flex-direction: column;
            top: 0; left: 0; right: 0; bottom: 0;
        }

        .txt-left{
            padding: 2rem 3rem;
            p{
                font-size: 1.5rem;
            }
        }

        .reservation{
            padding: 0rem 3rem;
        }

        .customer-infos{
            display: flex;
            flex-direction: column;
        }

        .input-container{
            p, input{
                font-size: 1.2rem;
                margin-bottom: 1rem;
            }
        }
        .selection{
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            padding: 2rem 0rem;
            width: 100%;
            text-align: center;
        }
        select{
            padding: .5rem 1rem;
            margin: .5rem 0rem;
            width: 100%;
            text-align: center;
        }

        .date-selector{
            flex-direction: column;
            gap: 1rem;
            padding-bottom: 2rem;
            .input{
                width: 10rem;
                justify-content: center;
            }
            p{
                font-size: 1.2rem;
            }
        }
    }
`

export const StyledBtn = styled.button`
    padding: .5rem 2rem;
    margin: auto;
    background: #6190e8;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    a{
        color: white;
    }
    @media (max-width: 768px){
        padding: 1rem 1rem;
        font-size: .8rem;
        background: #6190e8;
        border: none;
        border-radius: 5px;
        width: 100%;
        color: white;
        a{
            color: white;
        }
        font-size: 1.5rem;
    }
`